import { combineReducers } from 'redux';
import { Routine } from 'redux-saga-routines';
import { UsersAndTeamsState, usersAndTeams } from '../containers/UsersPane/reducer';
import { ProfileState, profile } from '../containers/ProfilePane/reducer';
import { EmailTemplatesState, emailTemplates } from '../containers/MessagesPane/reducer';
import { ApiTokensState, apiTokens } from '../containers/ApiTokensPane/reducer';
import { IntegrationsState, integrations } from '../containers/IntegrationsPane/reducer';
import {
  createApiTokenRoutine,
  deleteApiTokenRoutine,
  deactivateApiTokenRoutine,
  reactivateApiTokenRoutine,
  updateDefaultCountersRoutine,
  getApiTokensRoutine,
  disconnectFromLeverRoutine,
  setLeverSurveyRoutine,
  setLeverStageRoutine
} from '../routines';

export type SettingsState = {
  usersAndTeams: UsersAndTeamsState;
  profile: ProfileState;
  emailTemplates: EmailTemplatesState;
  apiTokens: ApiTokensState;
  integrations: IntegrationsState;
  isSaving: boolean;
}

const isSaving = (state = false, { type }: Routine<any>): boolean => {
  switch (type) {
    case createApiTokenRoutine.TRIGGER:
    case deleteApiTokenRoutine.TRIGGER:
    case deactivateApiTokenRoutine.TRIGGER:
    case reactivateApiTokenRoutine.TRIGGER:
    case updateDefaultCountersRoutine.TRIGGER:
    case getApiTokensRoutine.TRIGGER:
    case disconnectFromLeverRoutine.TRIGGER:
    case setLeverSurveyRoutine.TRIGGER:
    case setLeverStageRoutine.TRIGGER:
      return true;
    case createApiTokenRoutine.SUCCESS:
    case deleteApiTokenRoutine.SUCCESS:
    case deactivateApiTokenRoutine.SUCCESS:
    case reactivateApiTokenRoutine.SUCCESS:
    case updateDefaultCountersRoutine.SUCCESS:
    case getApiTokensRoutine.SUCCESS:
    case disconnectFromLeverRoutine.SUCCESS:
    case setLeverSurveyRoutine.SUCCESS:
    case setLeverStageRoutine.SUCCESS:
    case createApiTokenRoutine.FAILURE:
    case deleteApiTokenRoutine.FAILURE:
    case deactivateApiTokenRoutine.FAILURE:
    case reactivateApiTokenRoutine.FAILURE:
    case updateDefaultCountersRoutine.FAILURE:
    case getApiTokensRoutine.FAILURE:
    case disconnectFromLeverRoutine.FAILURE:
    case setLeverSurveyRoutine.FAILURE:
    case setLeverStageRoutine.FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  usersAndTeams,
  profile,
  emailTemplates,
  apiTokens,
  integrations,
  isSaving
});
